import { SelectProps } from './types';
import { useMemo } from 'react';

export const useInnerComponentsClassNames = <T>(controlClassName = '') => {
    const innerComponentsClassNames: SelectProps<T>['classNames'] = useMemo(
        () => ({
            control: () =>
                `min-h-[36px] bg-transparent rounded-none border-x-0 border-t-0 border-b border-[#cccccc] shadow-none ${controlClassName}`,
            placeholder: () => 'max-h-[36px]',
            valueContainer: () => 'p-[1px]',
            multiValue: () => 'border rounded-[2px] border-[#007eff3d] bg-[#007eff14] flex-row-reverse',
            multiValueLabel: () => 'text-[12.6px] text-[#007eff] px-[6px] py-1',
            multiValueRemove: () => `rounded-none text-[#007eff] hover:bg-[#d8eafd] border-e border-[#007eff3d]`,
            indicatorSeparator: () => 'hidden',
            dropdownIndicator: () => 'pe-0 h-[35px]',
            menu: () => '!z-[2] rounded-none',
            menuList: () => 'p-0',
            option: (state) =>
                !state.isDisabled
                    ? `cursor-pointer text-[#666666] hover:text-[#333] hover:bg-[#f5faff] ${
                          state.isSelected ? 'bg-[#f5faff] text-[#333]' : ''
                      }`
                    : ''
        }),
        [controlClassName]
    );

    return { innerComponentsClassNames };
};
